import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { StackInformationDialogData } from '@data-terminal/feature-dialogs/services/job-flow/stack-information-dialog.service';
import {
    HdmuiEmptyStatesComponent,
    HdmuiEmptyStatesDescriptionDirective,
    HdmuiEmptyStatesTitleDirective,
} from '@heidelberg/hdmui-angular';
import { TranslateModule } from '@ngx-translate/core';
import { JobFlowDiagramComponent } from './job-flow-diagram/job-flow-diagram.component';

@Component({
    selector: 'data-terminal-stack-information-dialog',
    imports: [
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        TranslateModule,
        JobFlowDiagramComponent,
        MatIcon,
        MatToolbar,
        HdmuiEmptyStatesComponent,
        HdmuiEmptyStatesTitleDirective,
        HdmuiEmptyStatesDescriptionDirective,
    ],
    templateUrl: './stack-information-dialog.component.html',
    styleUrl: './stack-information-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StackInformationDialogComponent {
    readonly #dialogRef = inject(MatDialogRef<StackInformationDialogComponent>);
    readonly dialogData: StackInformationDialogData = inject(MAT_DIALOG_DATA);

    public close(): void {
        this.#dialogRef.close();
    }
}
